import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
import { useSelector } from "react-redux";
const Department = (props) => {
  const { t } = useTranslation();
  const user = useSelector((state)=> state.login)
  const [attributes] = useState([
    {
      type: "text",
      placeholder: "department",
      name: "title",
      validation: "",
      default: "",
      label: "department",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    // {
    //   type: "select",
    //   placeholder: "select",
    //   name: "company",
    //   tab: "generalInfo",
    //   validation: "",
    //   showItem: "organization",
    //   default: user.data.user.company || "",
    //   label: "company",
    //   required: true,
    //   filter: false,
    //   view: true,
    //   tag: true,
    //   add: true,
    //   update: false,
    //   apiType: "API",
    //   selectApi: "company/admin/select",
    // },
  ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("department")} - Whistleblowing24`;
  }, [t]);

  return (
    <Container className="noshadow">
      <ListTable {...props} actions={[]} viewDetails={false} api={`department`} itemTitle={`title`} shortName={`department`} addPrivilege={true} delPrivilege={true} updatePrivilege={true} attributes={attributes} viewOnclick={false} ></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Department);
